import PropTypes from 'prop-types'

const TableUniqTwo = (props: any) => {
    return (
        <ul className='table-uniq-two'>
            <li>I/you/he (etc.)</li>
            <li>must</li>
            <li>can’t</li>
            <li>have</li>
            <li>be (tired / hungry / at work etc.)</li>
            <li>be (doing / going / joking etc.)</li>
            <li>do / get / know / have etc.</li>
        </ul>
    )
}

export default TableUniqTwo

TableUniqTwo.propTypes = {
    elements: PropTypes.array.isRequired
}
